"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MobileNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _reactRedux = require("react-redux");

var _ThemeConstant = require("../../constants/ThemeConstant");

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _MenuContent = _interopRequireDefault(require("./MenuContent"));

var _Theme = require("../../redux/actions/Theme");

var _Logo = _interopRequireDefault(require("./Logo"));

var _Flex = _interopRequireDefault(require("../../components/shared-components/Flex"));

var _icons = require("@ant-design/icons");

var MobileNav = function MobileNav(_ref) {
  var sideNavTheme = _ref.sideNavTheme,
      mobileNav = _ref.mobileNav,
      onMobileNavToggle = _ref.onMobileNavToggle,
      routeInfo = _ref.routeInfo,
      hideGroupTitle = _ref.hideGroupTitle,
      _ref$localization = _ref.localization,
      localization = _ref$localization === void 0 ? true : _ref$localization;
  var props = {
    sideNavTheme: sideNavTheme,
    routeInfo: routeInfo,
    hideGroupTitle: hideGroupTitle,
    localization: localization
  };

  var onClose = function onClose() {
    onMobileNavToggle(false);
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Drawer, {
    placement: "left",
    closable: false,
    onClose: onClose,
    visible: mobileNav,
    bodyStyle: {
      padding: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
    flexDirection: "column",
    className: "h-100"
  }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
    justifyContent: "between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    mobileLogo: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-close",
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowLeftOutlined, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-nav-menu"
  }, /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.Scrollbars, {
    autoHide: true
  }, /*#__PURE__*/_react.default.createElement(_MenuContent.default, Object.assign({
    type: _ThemeConstant.NAV_TYPE_SIDE
  }, props))))));
};

exports.MobileNav = MobileNav;

var mapStateToProps = function mapStateToProps(_ref2) {
  var theme = _ref2.theme;
  var navCollapsed = theme.navCollapsed,
      sideNavTheme = theme.sideNavTheme,
      mobileNav = theme.mobileNav;
  return {
    navCollapsed: navCollapsed,
    sideNavTheme: sideNavTheme,
    mobileNav: mobileNav
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  onMobileNavToggle: _Theme.onMobileNavToggle
})(MobileNav);

exports.default = _default;